// extracted by mini-css-extract-plugin
export default {"includeSaturday":"EducationClassForm_includeSaturday__zksY3"};